import Image from "next/image";
import styles from "./CookieConsentTitle.module.css";

export default function CookieConsentTitle(): JSX.Element {
  return (
    <div className={styles.title}>
      <Image
        src="/icons/cookie.svg"
        alt="Cookie"
        width={32}
        height={32}
        className="inline"
      />
      We Use Cookies
    </div>
  );
}
